import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { verifyEmail } from "../../api-interactions/authentication";

export const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const verifyHandler = async () => {
    const error = await verifyEmail(token);
    return navigate("/signin");
  };

  useEffect(() => {
    verifyHandler();
  }, []);

  return <div></div>;
};
